//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CursoAPI from '@/api/promotores/cursos.api'
import ExamenesAPI from "@/api/promotores/examenes.api";
import CategoriasAPI from "@/api/promotores/cursos/categorias.api";
import EspecialidadesAPI from "@/api/promotores/cursos/especialidades.api";

const fallback = {
  nombre: null,
  video: null,
  destacado: false,
  examen_id: null,
  categoria_id: null,
  especialidades: [],
  documento: null,
  portada: null,
  avatar: null,
  contenido: '',
  status: 'privado',
}

export default {
	props: {
		curso: {
			type: Object,
			default() {
				return fallback
			}
		}
	},

  data() {
    return {
      curso_: { ...fallback,...this.curso },

      documento: null,
      portada: null,
      avatar: null,

      loading: false,
      ratio: 20,
      tab: "config",

      examenes: [],
			optionsExamenes: [],
			loadingExamenes: false,

      categorias: [],
			optionsCategorias: [],
			loadingCategorias: false,

      especialidades: [],
			optionsEspecialidades: [],
			loadingEspecialidades: false,
    };
  },

  mounted() {
		// Borramos la url del documento,
		// para dejar limpio el input.
		// this.curso_.documento = null

    this.loadExamenes();
    this.loadCategorias();
    this.loadEspecialidades();
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    },

    hide() {
      this.$refs.dialog.hide();
    },

    async loadExamenes() {
			try {
				this.loadingExamenes = true
				this.examenes = await ExamenesAPI.all();
				this.optionsExamenes = this.examenes;
			} finally {
				this.loadingExamenes = false
			}
    },

    filterExamenes(val, update) {

      if (val === "") {
        update(() => {
          this.optionsExamenes = this.examenes;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();

        this.optionsExamenes = this.examenes.filter(
          (examen) => examen.nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },

    filterCategorias(val, update) {

      if (val === "") {
        update(() => {
          this.optionsCategorias = this.categorias;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();

        this.optionsCategorias = this.categorias.filter(
          (categoria) => categoria.nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },

		async loadCategorias() {
			try {
				this.loadingCategorias = true
				this.categorias = await CategoriasAPI.all()
				this.optionsCategorias = this.categorias;
			} finally {
				this.loadingCategorias = false
			}
		},

		async createCategoria(val, done) {
			try {
				this.loadingCategorias = true
				const categoria = await CategoriasAPI.create({ nombre: val })
				
				done(categoria)
				this.loadCategorias()
			} finally {
				this.loadingCategorias = false
			}
		},

		async loadEspecialidades() {
			try {
				this.loadingEspecialidades = true
				this.especialidades = await EspecialidadesAPI.all()
			} finally {
				this.loadingEspecialidades = false
			}
		},

		filterEspecialidades(val, update) {
      if (val === "") {
        update(() => {
          this.optionsEspecialidades = this.especialidades;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();

        this.optionsEspecialidades = this.especialidades.filter(
          (especialidad) => especialidad.nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },

    inputDocumento(file) {
      this.curso_.documento = URL.createObjectURL(file)
    },

    inputPortada(file) {
      this.curso_.portada = URL.createObjectURL(file)
    },

    inputAvatar(file) {
      this.curso_.avatar = URL.createObjectURL(file)
    },


    async submit() {
			try {
				this.loading = true

				let payload = {
					
					nombre: this.curso_.nombre,
					destacado: this.curso_.destacado,
					video: this.curso_.video,
					examen_id: this.curso_.examen_id,
					categoria_id: this.curso_.categoria_id,
					especialidades: (this.curso_.especialidades || []).map((especialidad) => especialidad.id)
				}

        if (this.curso_.id) {
          payload.id = this.curso_.id
        }

				if (this.documento !== null) {
					payload.documento = this.documento
				}

				if (this.portada !== null) {
					payload.portada = this.portada
				}

				if (this.avatar !== null) {
					payload.avatar = this.avatar
				}

				await CursoAPI.save(payload)

				this.$emit("ok", this.curso_);
      	this.hide();
			} finally {
				this.loading = false
			}
    },
  },
};
